// Gestion du code d'autorisation à usage unique (actions sensibles).
export const authCodeDetail = (err) => {
  const d = err?.response?.data?.detail;
  return d && typeof d === "object" && String(d.code || "").startsWith("AUTH_CODE") ? d : null;
};

export const apiErrAny = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object" && d.message) return d.message;
  return fallback(d);
};

// Exécute `run(authCode)` ; si le serveur exige un code, ouvre `ask(detail)` (Promise<string|null>) puis rejoue une fois.
export async function withAuthCode(run, ask) {
  try {
    return await run(null);
  } catch (err) {
    const d = authCodeDetail(err);
    if (!d || d.code !== "AUTH_CODE_REQUIRED") throw err;
    const code = await ask(d);
    if (!code) { const e = new Error("cancelled"); e.cancelled = true; throw e; }
    return await run(code);
  }
}
